import { Component, OnInit } from '@angular/core';
import { BaseComponentConfig, ComponentConfig, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { featureTypeOptions, feature_type_baseMenuItems } from './configoptions';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { baseMenuItems } from '../configoptions';

@Component({
  selector: 'ubs-feature-types',
  template: `<ubs-view-containers *ngIf="menuSet" [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./feature-types.component.scss']
})
export class FeatureTypesComponent extends BaseComponentConfig implements OnInit {
  menuSet = false;  
  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    private http:HttpClient,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService) {
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    this.componentConfig = new ComponentConfig(featureTypeOptions);
   }
  ngOnInit(): void {
    this.baseUrl = this.getBaseUrl();
    let menuAndTitleOptions = this.componentConfig.getMenuAndTitleOptions();
    let menuTag = menuAndTitleOptions.menuTag;
    let menuItems:NbMenuItem[] = [];
    console.log(menuTag)
    baseMenuItems.forEach(item => {
      menuItems.push(item);
    });
    //menuItems.push({title:"Recent Product Feature Category",group:true,icon:"grid-outline"})
    
    /* feature_type_baseMenuItems.forEach(item => {
      menuItems.push(item);
    }) */
    this.componentConfig.menuAndTitleOptions.menuItems = menuItems;
    this.menuSet = true;
    setTimeout(() => {
      console.log(menuItems,menuTag);
      //this.menuService.addItems(menuItems,"featuresMenu")
      
      let something = this.viewContainerService.getMenu("features");
      console.log(something)
    }, 2000);
    
    //this.viewContainerService.getMenuItems().subscribe(resp => {console.log(resp)})
  }
}
